/**
 * Copyright 2021 GeoComply
 * Author: Hao Nguyen (hao@geocomply.com)
 * 
 * Emitting events of GeoComply React Native Module
 * 
 * List of events:
 * 
 * - GEOCOMPLY_GEOLOCATION_AVAILABLE_EVENT: this event indicates a successful geolocation request.
 * When firing this event, GeoComply React Native Module will send along geolocation data response from Engine Server.
 * 
 * - GEOCOMPLY_GEOLOCATION_FAILED_EVENT: this event indicates a failed geolocation request.
 * When firing this event, GeoComply React Native Module will send along error code and message to the listener.
 * 
 * - GEOCOMPLY_GEOLOCATION_CANCELLATION_FINISHED_EVENT: this event indicates GeoComply React Native Module has finished the cancellation request.
 * When firing this event, GeoComply React Native Module will send along log message to the listener.
 *
 * - GEOCOMPLY_GEOLOCATION_STOPPED_UPDATING_EVENT: this event indicates GeoComply React Native Module has stopped updating indoor geolocation.
 * When firing this event, GeoComply React Native Module will send along log message to the listener.
 * 
 * - GEOCOMPLY_MYIP_SUCCESS_EVENT: this event indicates changed IP.
 * When firing this event, GeoComply React Native Module will send along log message to the listener.
 * 
 * - GEOCOMPLY_MYIP_FAILED_EVENT: this event indicates there is an error when detecting IP change.
 * When firing this event, GeoComply React Native Module will send along log message to the listener.
 * 
 * - GEOCOMPLY_GEOLOCATION_BLUETOOTH_ERROR_EVENT: this event indicates GeoComply React Native Module a failed indoor geolocation request by bluetooth.
 * When firing this event, GeoComply React Native Module will send along error code and message to the listener.
 */

export const GEOCOMPLY_GEOLOCATION_AVAILABLE_EVENT = "onGeolocationAvailable"
export const GEOCOMPLY_GEOLOCATION_FAILED_EVENT = "onGeoComplyError"
export const GEOCOMPLY_MYIP_SUCCESS_EVENT = "onMyIpSuccessEvent";
export const GEOCOMPLY_MYIP_FAILED_EVENT = "onMyIpFailedEvent";
export const GEOCOMPLY_GEOLOCATION_CANCELLATION_FINISHED_EVENT = "onGeolocationCancellationFinishedEvent";
export const GEOCOMPLY_GEOLOCATION_STOPPED_UPDATING_EVENT = "onGeolocationStoppedUpdatingEvent";
export const GEOCOMPLY_GEOLOCATION_BLUETOOTH_ERROR_EVENT = "onGeolocationBluetoothErrorEvent";